const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.7756,
    y1: 250,
    x2: 462.2244,
    y2: 250
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B388FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.17,
      fill: "url(#SVGID_1_)"
    },
    d: "M419.625,253.477c-10.53,14.07-17.99,32.53-12.17,49.12 c7.45,21.23,33.59,31.62,40.67,52.98c5.54,16.75-2.64,35.24-14.31,48.47c-11.68,13.24-26.71,23.11-38.83,35.93 c-5.83,6.17-11.03,13.45-14.43,21.26c-0.48,1.09-0.92,2.19-1.31,3.3H97.235c-0.84-1.12-1.72-2.22-2.62-3.3 c-5.44-6.6-11.67-12.69-17.87-18.58c-12.43-11.8-25.4-23.67-33.04-39c-7.64-15.34-8.8-35.24,1.91-48.61 c9.91-12.37,27.57-16.69,36.93-29.47c13.14-17.94,4.35-43.13-5.73-62.96c-13.78-27.13-29.57-54.27-33.16-84.48 s8.96-64.96,37.22-76.25c33.37-13.34,73.07,10.36,106.42-3.01c28.15-11.27,41.64-45.03,68.99-58.11 c14.45-6.91,31.97-7.08,46.55-0.44c14.58,6.64,25.96,19.95,30.24,35.39c4.8,17.3,1.41,37.43,11.98,51.94 c11.97,16.41,35.59,17.56,55.91,17.31s44.04,1.34,55.51,18.11c9.92,14.51,5.84,34.76-3.42,49.69 C443.795,227.707,430.155,239.397,419.625,253.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D5A64"
    },
    d: "M436.375,464.537H40.445c-2.53,0-2.53-3.3,0-3.3h395.93 C438.905,461.237,438.905,464.537,436.375,464.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M139.867,461.237c0.467-22.62,3.994-45.481,10.475-68.249 c-2.927,1.179-5.757,2.499-8.486,3.941c-1.812,8.421-3.507,16.921-6.991,25.225c-0.266,0.634-1.817,0.615-1.849,0 c-0.362-6.961,0.723-14.111,2.036-21.229c-4.403,2.866-8.463,6.086-12.117,9.611c2.063,6.948,4.223,13.894,5.987,20.901 c1.884,7.484,4.475,14.845,4.932,22.586c0.053,0.89-1.822,1.501-2.359,0.64c-4.3-6.893-6.396-14.405-9.403-21.676 c-2.091-5.056-3.847-10.221-5.613-15.374c-4.565,5.707-8.178,11.995-10.639,18.707c7.528,7.803,13.724,16.177,18.971,24.915 H139.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M151.697,461.237c0.024-2.215,0.059-4.43,0.12-6.649c0.338-12.414,1.256-24.936,3.073-37.435 c0.908-6.248,1.699-12.531,3.14-18.786c0.67-2.911,1.406-5.812,2.157-8.712c-1.687,0.471-3.354,0.978-4.991,1.534 c-0.289,0.983-0.577,1.966-0.855,2.95c-6.31,22.362-9.759,44.852-10.304,67.098H151.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M168.707,461.237c0.553-24.513-0.103-48.921-1.966-73.176c-1.008,0.207-2.008,0.43-3.001,0.667 c-0.447,4.113-0.812,8.227-1.296,12.325c-0.803,6.804-1.572,13.594-2.183,20.389c-1.197,13.314-1.671,26.587-1.489,39.795 H168.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M233.041,461.237c9.007-11.813,19.275-23.289,30.682-34.275 c-0.736-1.315-1.524-2.606-2.351-3.875c-2.691,2.993-5.258,6.197-8.751,8.732c-0.606,0.44-1.711,0.075-1.54-0.462 c1.214-3.818,4.969-7.694,7.991-11.14c0.059-0.067,0.121-0.134,0.179-0.201c-1.109-1.518-2.283-2.997-3.52-4.436 c-0.568,0.882-1.145,1.762-1.704,2.645c-4.219,6.674-8.032,13.463-12.799,20.013c-0.69,0.948-2.962,0.86-2.645-0.249 c2.563-8.994,7.376-18.066,12.944-26.908c-2.52-2.486-5.235-4.828-8.135-7.002c-6.615,19.033-12.828,38.09-18.825,57.158 H233.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M173.325,461.237h15.648c10.25-22.764,22.469-45.295,36.591-67.432 c-2.649-1.14-5.381-2.159-8.182-3.064c-0.514,0.775-1.044,1.546-1.55,2.322c-5.07,7.785-9.919,15.648-14.215,23.579 c-4.36,8.047-7.715,16.386-12.833,24.274c-0.756,1.166-3.174,0.907-2.995-0.282c1.233-8.186,5.431-16.671,9.35-24.7 c3.993-8.18,8.363-16.289,13.417-24.295c0.604-0.956,1.236-1.906,1.853-2.86c-2.567-0.619-5.183-1.142-7.844-1.557 c-0.894,2.632-1.591,5.279-2.306,7.951c-0.284,1.063-2.721,1.363-2.853,0.259c-0.342-2.871,0.009-5.834,0.82-8.786 c-2.307-0.257-4.643-0.437-7.005-0.535c-3.262,10.711-5.736,21.422-8.232,32.155c-0.317,1.362-3.029,1.269-3.005,0 c0.197-10.655,2.127-21.483,5.075-32.229c-4.703,0.088-9.311,0.498-13.795,1.204c0.2,2.527,0.399,5.053,0.573,7.583 C173.35,416.856,173.8,439.006,173.325,461.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M271.607,461.237c0.093-1.367,0.141-2.744,0.138-4.131c-0.003-1.334-0.064-2.655-0.154-3.97 c-3.222,2.661-6.361,5.364-9.429,8.102H271.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M254.232,461.237c5.231-5.005,10.754-9.886,16.559-14.62c-0.424-2.379-0.991-4.717-1.687-7.013 c-1.554,1.464-3.076,2.943-4.548,4.447c-2.958,3.025-5.661,6.914-9.769,9.33c-0.481,0.283-1.15,0.072-1.082-0.325 c0.581-3.384,4.31-7.063,6.998-10.069c2.242-2.506,4.583-4.994,7.032-7.433c-0.415-1.093-0.854-2.178-1.33-3.247 c-9.467,9.334-18.099,19.005-25.822,28.929H254.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M120.655,461.237c-4.567-7.501-9.811-14.733-15.945-21.54 c-0.901,2.975-1.574,6.026-2.014,9.136c4,3.828,7.425,7.964,9.962,12.404H120.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M109.784,461.237c-2.541-2.201-5.066-4.408-7.626-6.594c-0.042,0.94-0.069,1.882-0.067,2.83 c0.003,1.263,0.049,2.517,0.13,3.764H109.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M203.908,461.237c1.907-4.828,3.874-9.652,5.916-14.468 c4.165-9.826,8.741-19.615,13.475-29.374c3.158-6.509,6.086-13.327,9.81-19.897c-0.652-0.355-1.296-0.719-1.96-1.06 c-13.616,21.3-25.435,42.943-35.495,64.799H203.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M217.601,461.237c6.387-20.377,13.005-40.743,20.089-61.078 c-0.667-0.419-1.355-0.816-2.038-1.218c-1.032,2.006-2.085,4.007-3.061,6.005c-2.654,5.428-5.271,10.862-7.784,16.308 c-6.12,13.262-11.579,26.605-16.548,39.984H217.601z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M317.376,461.237c0.313-15.153,2.676-30.467,7.017-45.719c-1.961,0.79-3.856,1.674-5.685,2.64 c-1.214,5.641-2.35,11.335-4.684,16.898c-0.178,0.425-1.217,0.412-1.238,0c-0.242-4.663,0.484-9.453,1.364-14.221 c-2.95,1.92-5.669,4.077-8.117,6.438c1.382,4.654,2.829,9.308,4.011,14.002c1.262,5.013,2.997,9.945,3.304,15.13 c0.035,0.596-1.22,1.006-1.58,0.429c-2.881-4.618-4.284-9.65-6.299-14.521c-1.401-3.387-2.577-6.847-3.76-10.298 c-3.058,3.823-5.479,8.035-7.127,12.532c5.043,5.227,9.194,10.837,12.708,16.69H317.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M325.301,461.237c0.016-1.484,0.04-2.968,0.08-4.454c0.227-8.316,0.841-16.704,2.058-25.077 c0.608-4.185,1.138-8.395,2.103-12.584c0.449-1.95,0.942-3.894,1.445-5.836c-1.13,0.315-2.247,0.655-3.344,1.027 c-0.194,0.659-0.387,1.317-0.573,1.976c-4.227,14.98-6.538,30.046-6.903,44.948H325.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M336.696,461.237c0.371-16.421-0.069-32.772-1.317-49.02c-0.675,0.139-1.345,0.288-2.011,0.447 c-0.3,2.755-0.544,5.511-0.868,8.257c-0.538,4.558-1.053,9.106-1.462,13.658c-0.802,8.919-1.119,17.811-0.998,26.658H336.696z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M379.792,461.237c6.034-7.913,12.912-15.601,20.553-22.961 c-0.493-0.881-1.021-1.746-1.575-2.596c-1.802,2.005-3.522,4.151-5.862,5.85c-0.406,0.294-1.146,0.05-1.032-0.31 c0.813-2.558,3.329-5.154,5.353-7.463c0.04-0.045,0.081-0.09,0.12-0.134c-0.743-1.017-1.529-2.008-2.358-2.972 c-0.381,0.591-0.767,1.18-1.141,1.772c-2.826,4.471-5.381,9.019-8.574,13.407c-0.462,0.635-1.984,0.576-1.772-0.167 c1.717-6.025,4.941-12.102,8.671-18.025c-1.688-1.665-3.507-3.234-5.449-4.69c-4.431,12.75-8.593,25.516-12.611,38.29H379.792 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M339.79,461.237h10.482c6.866-15.249,15.051-30.343,24.512-45.172 c-1.774-0.763-3.605-1.446-5.481-2.052c-0.345,0.519-0.699,1.035-1.038,1.555c-3.396,5.215-6.644,10.483-9.523,15.796 c-2.92,5.391-5.168,10.977-8.597,16.261c-0.507,0.781-2.126,0.608-2.006-0.189c0.826-5.484,3.638-11.167,6.264-16.546 c2.675-5.48,5.602-10.912,8.988-16.275c0.405-0.641,0.828-1.277,1.241-1.916c-1.72-0.415-3.472-0.765-5.254-1.043 c-0.599,1.763-1.066,3.536-1.544,5.326c-0.19,0.712-1.823,0.913-1.911,0.173c-0.229-1.923,0.006-3.908,0.549-5.886 c-1.546-0.172-3.11-0.293-4.693-0.359c-2.185,7.175-3.842,14.35-5.514,21.54c-0.212,0.912-2.029,0.85-2.013,0 c0.132-7.138,1.425-14.392,3.4-21.59c-3.15,0.059-6.237,0.334-9.241,0.806c0.134,1.692,0.267,3.385,0.384,5.08 C339.806,431.506,340.108,446.345,339.79,461.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M405.627,461.237c0.062-0.916,0.095-1.838,0.092-2.768c-0.002-0.893-0.043-1.779-0.103-2.66 c-2.158,1.782-4.261,3.593-6.316,5.427H405.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M393.988,461.237c3.504-3.353,7.204-6.622,11.092-9.794c-0.284-1.594-0.664-3.16-1.13-4.698 c-1.041,0.981-2.061,1.971-3.046,2.979c-1.981,2.026-3.792,4.632-6.544,6.25c-0.322,0.19-0.771,0.048-0.725-0.218 c0.389-2.267,2.887-4.731,4.688-6.745c1.502-1.679,3.07-3.346,4.711-4.979c-0.278-0.732-0.572-1.459-0.891-2.175 c-6.342,6.253-12.124,12.731-17.298,19.379H393.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M304.507,461.237c-3.059-5.025-6.572-9.869-10.681-14.429c-0.604,1.993-1.054,4.036-1.349,6.12 c2.68,2.564,4.974,5.335,6.673,8.309H304.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M297.225,461.237c-1.702-1.474-3.394-2.953-5.108-4.417c-0.028,0.629-0.046,1.261-0.045,1.896 c0.002,0.846,0.033,1.686,0.087,2.521H297.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M360.277,461.237c1.277-3.234,2.595-6.466,3.963-9.692c2.79-6.582,5.855-13.14,9.027-19.677 c2.115-4.36,4.077-8.927,6.571-13.329c-0.436-0.238-0.868-0.481-1.313-0.71c-9.121,14.269-17.039,28.767-23.777,43.408 H360.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M369.45,461.237c4.279-13.65,8.712-27.293,13.457-40.915c-0.447-0.281-0.908-0.546-1.365-0.816 c-0.691,1.344-1.396,2.684-2.051,4.022c-1.778,3.636-3.531,7.276-5.214,10.924c-4.099,8.884-7.757,17.822-11.086,26.785 H369.45z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M376.16,156.736c-24.682,0-44.762-20.08-44.762-44.761c0-24.682,20.08-44.762,44.762-44.762 c24.682,0,44.761,20.08,44.761,44.762C420.921,136.657,400.842,156.736,376.16,156.736z M376.16,68.213 c-24.13,0-43.762,19.631-43.762,43.762c0,24.13,19.631,43.761,43.762,43.761c24.13,0,43.761-19.631,43.761-43.761 C419.921,87.845,400.29,68.213,376.16,68.213z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C5CAE9"
    },
    cx: 376.16,
    cy: 111.975,
    r: 1.384
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M376.16,73.66c-0.276,0-0.5-0.224-0.5-0.5v-3.341c0-0.276,0.224-0.5,0.5-0.5 c0.276,0,0.5,0.224,0.5,0.5v3.341C376.66,73.436,376.436,73.66,376.16,73.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M376.16,154.631c-0.276,0-0.5-0.224-0.5-0.5v-3.341c0-0.276,0.224-0.5,0.5-0.5 c0.276,0,0.5,0.224,0.5,0.5v3.341C376.66,154.407,376.436,154.631,376.16,154.631z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M418.316,112.475h-3.341c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h3.341 c0.276,0,0.5,0.224,0.5,0.5C418.816,112.251,418.592,112.475,418.316,112.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M337.345,112.475h-3.341c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h3.341 c0.276,0,0.5,0.224,0.5,0.5C337.845,112.251,337.621,112.475,337.345,112.475z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M403.606,85.029c-0.128,0-0.256-0.049-0.353-0.146c-0.195-0.195-0.195-0.512,0-0.707 l2.363-2.362c0.195-0.195,0.512-0.195,0.707,0c0.195,0.195,0.195,0.512,0,0.707l-2.363,2.362 C403.862,84.98,403.734,85.029,403.606,85.029z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M346.351,142.283c-0.128,0-0.256-0.049-0.353-0.146c-0.195-0.195-0.195-0.512,0-0.707 l2.362-2.363c0.195-0.195,0.512-0.195,0.707,0c0.195,0.195,0.195,0.512,0,0.707l-2.362,2.363 C346.607,142.235,346.479,142.283,346.351,142.283z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M405.969,142.283c-0.128,0-0.256-0.049-0.354-0.146l-2.363-2.363 c-0.195-0.195-0.195-0.512,0-0.707c0.195-0.195,0.512-0.195,0.707,0l2.363,2.363c0.195,0.195,0.195,0.512,0,0.707 C406.224,142.235,406.096,142.283,405.969,142.283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M348.714,85.029c-0.128,0-0.256-0.049-0.353-0.146l-2.362-2.362 c-0.195-0.195-0.195-0.512,0-0.707c0.195-0.195,0.512-0.195,0.707,0l2.362,2.362c0.195,0.195,0.195,0.512,0,0.707 C348.97,84.98,348.842,85.029,348.714,85.029z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M353.185,127.336c-0.164,0-0.325-0.081-0.42-0.229c-0.15-0.232-0.084-0.542,0.148-0.691 l22.747-14.713V81.524c0-0.276,0.224-0.5,0.5-0.5c0.276,0,0.5,0.224,0.5,0.5v30.723l-23.204,15.009 C353.372,127.31,353.278,127.336,353.185,127.336z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M183.36,126.03l-0.378-0.437c-0.646-0.747-15.825-18.386-15.825-27.144 c0-8.934,7.269-16.203,16.203-16.203c8.935,0,16.203,7.269,16.203,16.203c0,8.758-15.179,26.397-15.825,27.144L183.36,126.03z  M183.36,83.246c-8.383,0-15.203,6.82-15.203,15.203c0,7.646,12.819,23.216,15.203,26.044 c2.384-2.829,15.203-18.398,15.203-26.044C198.564,90.066,191.743,83.246,183.36,83.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M183.36,108.015c-5.274,0-9.565-4.291-9.565-9.566c0-5.274,4.291-9.565,9.565-9.565 c5.275,0,9.566,4.291,9.566,9.565C192.926,103.724,188.635,108.015,183.36,108.015z M183.36,89.883 c-4.723,0-8.565,3.842-8.565,8.565c0,4.723,3.842,8.566,8.565,8.566c4.723,0,8.566-3.843,8.566-8.566 C191.926,93.726,188.084,89.883,183.36,89.883z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M390.978,350.53l-0.378-0.437c-0.647-0.747-15.825-18.386-15.825-27.144 c0-8.934,7.269-16.203,16.203-16.203c8.935,0,16.203,7.268,16.203,16.203c0,8.758-15.179,26.397-15.825,27.144L390.978,350.53z  M390.978,307.747c-8.383,0-15.203,6.82-15.203,15.203c0,7.646,12.819,23.216,15.203,26.044 c2.384-2.829,15.203-18.398,15.203-26.044C406.181,314.567,399.361,307.747,390.978,307.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M390.978,332.516c-5.275,0-9.565-4.291-9.565-9.566c0-5.274,4.291-9.565,9.565-9.565 c5.275,0,9.566,4.291,9.566,9.565C400.544,328.225,396.253,332.516,390.978,332.516z M390.978,314.384 c-4.723,0-8.565,3.842-8.565,8.565c0,4.723,3.842,8.566,8.565,8.566c4.723,0,8.566-3.843,8.566-8.566 C399.544,318.227,395.701,314.384,390.978,314.384z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#C5CAE9",
      strokeMiterlimit: 10
    },
    points: "183.36,128.812 105.634,199.249 296.263,251.933  231.961,392.899 349.214,407.706 386.775,358.815  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M385.638,199.479v8.101H384.1l-4.039-4.918v4.918h-1.852v-8.101h1.551l4.028,4.918v-4.918 H385.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M388.214,203.529c0-2.407,1.875-4.189,4.432-4.189c2.546,0,4.432,1.771,4.432,4.189 c0,2.419-1.886,4.19-4.432,4.19C390.089,207.719,388.214,205.936,388.214,203.529z M395.181,203.529 c0-1.539-1.088-2.592-2.534-2.592c-1.447,0-2.535,1.053-2.535,2.592c0,1.539,1.088,2.592,2.535,2.592 C394.093,206.121,395.181,205.068,395.181,203.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M401.217,201.007h-2.593v-1.528h7.06v1.528h-2.593v6.573h-1.875V201.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M414.125,206.076v1.504h-6.273v-8.101h6.122v1.504h-4.258v1.76h3.761v1.458h-3.761v1.875 H414.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M416.145,206.781l0.636-1.411c0.683,0.498,1.702,0.844,2.674,0.844 c1.11,0,1.562-0.37,1.562-0.868c0-1.516-4.71-0.474-4.71-3.483c0-1.378,1.112-2.523,3.414-2.523 c1.018,0,2.06,0.243,2.811,0.718l-0.579,1.423c-0.751-0.428-1.527-0.636-2.244-0.636c-1.112,0-1.54,0.417-1.54,0.925 c0,1.493,4.71,0.463,4.71,3.437c0,1.354-1.122,2.511-3.437,2.511C418.159,207.719,416.862,207.337,416.145,206.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.459,
    y: 210.286,
    style: {
      fill: "#C5CAE9"
    },
    width: 42.704,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.459,
    y: 212.683,
    style: {
      fill: "#C5CAE9"
    },
    width: 42.704,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.459,
    y: 215.079,
    style: {
      fill: "#C5CAE9"
    },
    width: 42.704,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.459,
    y: 217.475,
    style: {
      fill: "#C5CAE9"
    },
    width: 26.578,
    height: 1.338
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M376.472,255.3l-0.01-3.89l-1.908,3.204h-0.676l-1.898-3.121v3.807h-1.408v-6.483h1.241 l2.427,4.029l2.39-4.029h1.232l0.018,6.483H376.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M384.439,254.096v1.204h-5.021v-6.483h4.899v1.204h-3.408v1.408h3.011v1.167h-3.011v1.5H384.439 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M390.656,254.096v1.204h-5.021v-6.483h4.899v1.204h-3.408v1.408h3.011v1.167h-3.011v1.5H390.656 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M393.194,250.039h-2.074v-1.223h5.649v1.223h-2.074v5.261h-1.501V250.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M397.577,248.817h1.501v6.483h-1.501V248.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M406.561,248.817v6.483h-1.232l-3.232-3.936v3.936h-1.482v-6.483h1.241l3.224,3.937v-3.937 H406.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M412.481,251.956h1.371v2.631c-0.713,0.537-1.695,0.824-2.621,0.824 c-2.038,0-3.538-1.398-3.538-3.354c0-1.954,1.5-3.353,3.565-3.353c1.14,0,2.084,0.389,2.714,1.121l-0.963,0.889 c-0.473-0.5-1.019-0.731-1.677-0.731c-1.26,0-2.121,0.843-2.121,2.074c0,1.214,0.861,2.075,2.103,2.075 c0.408,0,0.787-0.074,1.167-0.278V251.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M414.734,254.661l0.509-1.131c0.547,0.398,1.361,0.677,2.14,0.677c0.89,0,1.25-0.297,1.25-0.694 c0-1.214-3.77-0.38-3.77-2.789c0-1.102,0.89-2.019,2.733-2.019c0.815,0,1.648,0.195,2.251,0.574l-0.463,1.139 c-0.603-0.342-1.223-0.509-1.797-0.509c-0.89,0-1.232,0.333-1.232,0.741c0,1.194,3.77,0.37,3.77,2.751 c0,1.083-0.898,2.01-2.75,2.01C416.345,255.411,415.308,255.106,414.734,254.661z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 261.508,
    style: {
      fill: "#C5CAE9"
    },
    width: 26.578,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 263.904,
    style: {
      fill: "#C5CAE9"
    },
    width: 26.578,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 266.301,
    style: {
      fill: "#C5CAE9"
    },
    width: 16.542,
    height: 1.338
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 274.065,
    style: {
      fill: "#C5CAE9"
    },
    width: 26.578,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 276.462,
    style: {
      fill: "#C5CAE9"
    },
    width: 26.578,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 278.858,
    style: {
      fill: "#C5CAE9"
    },
    width: 16.542,
    height: 1.338
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 285.48,
    style: {
      fill: "#C5CAE9"
    },
    width: 26.578,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 287.877,
    style: {
      fill: "#C5CAE9"
    },
    width: 26.578,
    height: 1.338
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.718,
    y: 290.273,
    style: {
      fill: "#C5CAE9"
    },
    width: 16.542,
    height: 1.338
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M373.223,259.707v8.396h-1.943v-6.836H369.6v-1.56H373.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M374.776,279.148v1.583h-6.345v-1.26l3.238-3.058c0.744-0.708,0.876-1.14,0.876-1.548 c0-0.659-0.456-1.043-1.344-1.043c-0.72,0-1.331,0.275-1.739,0.84l-1.415-0.912c0.647-0.947,1.823-1.559,3.334-1.559 c1.871,0,3.119,0.959,3.119,2.482c0,0.815-0.228,1.56-1.403,2.65l-1.932,1.823H374.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5CAE9"
    },
    d: "M374.751,290.105c0,1.415-1.091,2.71-3.478,2.71c-1.176,0-2.387-0.323-3.202-0.899l0.755-1.487 c0.636,0.48,1.523,0.756,2.399,0.756c0.971,0,1.571-0.396,1.571-1.079c0-0.636-0.468-1.031-1.571-1.031h-0.888v-1.283 l1.727-1.955h-3.573v-1.56h5.876v1.26l-1.895,2.158C373.984,287.934,374.751,288.87,374.751,290.105z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#3949AB"
    },
    d: "M339.521,389.655H225.48c-5.077,0-8.761-4.115-8.23-9.192l26.02-248.619 c0.531-5.077,5.077-9.192,10.154-9.192h114.041c5.077,0,8.761,4.115,8.23,9.192l-26.02,248.619 C349.144,385.54,344.598,389.655,339.521,389.655z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D6E79"
    },
    d: "M216.531,111.364L183.34,365.108c-0.208,1.587,1.614,4.389,3.327,6.547 c1.226,1.544,3.099,2.431,5.071,2.431h138.278c4.82,0,6.882-5.249,7.298-8.734l29.758-249.002 c0.659-5.513-2.783-10.688-8.122-12.212l0,0l0,0l-137.199,2.558C219.095,106.745,216.875,108.73,216.531,111.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E8E99"
    },
    d: "M189.758,310.779l-6.368,53.541c-0.285,2.392,1.584,4.496,3.993,4.496h135.057 c2.783,0,5.126-2.081,5.455-4.844l15.34-128.97c-51.557,20.309-101.081,44.649-151.596,74.676 C191.003,310.032,190.377,310.401,189.758,310.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94A1AB"
    },
    d: "M213.92,108.865l-24.163,201.913c0.62-0.377,1.245-0.746,1.88-1.102 c50.515-30.027,100.039-54.367,151.596-74.676l14.961-124.579c0.402-3.342-2.208-6.285-5.575-6.285H219.247 C216.531,104.138,214.243,106.168,213.92,108.865z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180349690183985675690000003593063600032057018_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.2837,
    y1: 120.4767,
    x2: 264.9032,
    y2: 399.0082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B388FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180349690183985675690000003593063600032057018_)"
    },
    d: "M314.853,108.416l-0.409,2.367 c-0.576,3.338-3.471,5.776-6.858,5.776h-47.313c-4.317,0-7.592-3.889-6.858-8.143l0,0h-35.879l-30.619,256.122H322.05 l30.619-256.122H314.853z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "243.856,177.434 223.159,177.434 225.863,156.736 246.56,156.736  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "285.275,177.434 264.578,177.434 267.282,156.736 287.979,156.736  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8185,
      strokeMiterlimit: 10
    },
    points: "326.694,177.434 305.996,177.434  308.7,156.736 329.398,156.736  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "238.99,214.683 218.292,214.683 220.996,193.986 241.694,193.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8185,
      strokeMiterlimit: 10
    },
    points: "280.408,214.683 259.711,214.683  262.415,193.986 283.112,193.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "321.827,214.683 301.13,214.683 303.834,193.986 324.531,193.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "234.123,251.933 213.426,251.933 216.13,231.236 236.827,231.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "275.542,251.933 254.844,251.933 257.548,231.236 278.246,231.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "316.96,251.933 296.263,251.933 298.967,231.236 319.665,231.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8185,
      strokeMiterlimit: 10
    },
    points: "229.257,289.183 208.559,289.183  211.263,268.486 231.961,268.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "270.675,289.183 249.978,289.183 252.682,268.486 273.379,268.486  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0243,
      strokeMiterlimit: 10
    },
    d: "M298.081,327.445h-84.546 c-6.248,0-11.071-5.494-10.262-11.689l0,0c0.673-5.153,5.064-9.008,10.262-9.008h84.546c6.248,0,11.071,5.494,10.262,11.689l0,0 C307.669,323.59,303.279,327.445,298.081,327.445z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "312.094,289.183 291.397,289.183 294.101,268.486 314.798,268.486  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.278,190.73c-3.138,3.519-6.275,7.038-9.412,10.558c-1.343,1.507-2.656,3.374-4.183,4.692 c-1.221,1.054-1.294,1.618-2.736,0.812c-0.806-0.45-1.689-1.833-2.279-2.474c-1.251-1.358-3.703,0.804-2.449,2.166 c2.566,2.785,4.521,6.915,8.338,2.801c5.164-5.565,10.115-11.345,15.164-17.01C288.119,190.708,285.659,189.18,284.278,190.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.852,151.697c-3.137,3.519-6.275,7.038-9.412,10.558c-1.343,1.507-2.656,3.374-4.183,4.692 c-1.221,1.054-1.294,1.618-2.736,0.812c-0.806-0.45-1.689-1.833-2.279-2.474c-1.251-1.358-3.703,0.804-2.449,2.166 c2.566,2.785,4.521,6.915,8.338,2.801c5.164-5.565,10.115-11.345,15.164-17.009 C335.693,151.675,333.234,150.148,331.852,151.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.401,263.353c-3.137,3.519-6.275,7.038-9.412,10.558c-1.343,1.507-2.657,3.374-4.183,4.692 c-1.221,1.054-1.294,1.618-2.736,0.812c-0.806-0.45-1.688-1.833-2.279-2.474c-1.251-1.358-3.703,0.804-2.449,2.166 c2.566,2.785,4.521,6.915,8.338,2.801c5.164-5.565,10.115-11.345,15.164-17.009C238.241,263.33,235.782,261.803,234.401,263.353 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9916 0 -0.1295 0.9916 240.1716 146.748)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Montserrat-Bold'",
      fontSize: "8.5042px",
      letterSpacing: 1.009
    }
  }, "APPOINTMENT")), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0243,
      strokeMiterlimit: 10
    },
    cx: 295.896,
    cy: 316.262,
    r: 4.99
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0243,
      strokeMiterlimit: 10
    },
    x1: 298.561,
    y1: 320.476,
    x2: 300.887,
    y2: 323.799
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8128,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 332.621,
    y1: 122.652,
    x2: 343.234,
    y2: 122.652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8128,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 332.009,
    y1: 125.741,
    x2: 342.622,
    y2: 125.741
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8128,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 331.398,
    y1: 128.829,
    x2: 342.011,
    y2: 128.829
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8128,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 206.25,
    y1: 343.108,
    x2: 297.779,
    y2: 343.108
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8128,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 205.638,
    y1: 346.197,
    x2: 297.168,
    y2: 346.197
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.8128,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 205.027,
    y1: 349.285,
    x2: 296.557,
    y2: 349.285
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6C748A"
    },
    d: "M196.317,229.276c2.118,1.845,4.279,3.742,5.643,6.197c1.364,2.456,1.793,5.624,0.361,8.04 c-1.619,2.731-5.198,3.778-8.341,3.328c-3.143-0.451-5.966-2.103-8.698-3.722c-2.855-1.692-12.088-7.263-14.943-8.955 c-7.165-4.247-15.022-9.435-16.602-17.614c-0.607-3.141-0.118-6.575,1.764-9.162c5.451-7.493,11.5-1.971,16.441,2.333 C177.94,214.947,190.318,224.051,196.317,229.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6C748A"
    },
    d: "M198.686,229.774l40.77-5.935c1.378,3.742,1.118,3.035,2.496,6.777 c-11.719,7.336-25.075,12.947-38.699,15.401c-3.503,0.631-7.288,1.052-10.474-0.533c-3.186-1.586-5.206-5.944-3.154-8.851l0,0 C191.271,232.944,194.69,230.355,198.686,229.774z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A65"
    },
    d: "M255.002,220.101c-0.32-1.183-2.19-0.783-1.868,0.409c0.59,2.184-0.081,4.343-1.822,5.795 c-0.947,0.791,0.33,2.214,1.273,1.427C254.818,225.87,255.761,222.909,255.002,220.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAB91"
    },
    d: "M256.666,219.916c-0.32-1.183-2.19-0.783-1.868,0.409c0.59,2.184-0.081,4.343-1.822,5.796 c-0.948,0.791,0.33,2.214,1.273,1.427C256.482,225.685,257.425,222.724,256.666,219.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CABA"
    },
    d: "M239.456,223.839l12.424-4.753l10.476-7.764c0.048-0.035,0.115,0.001,0.111,0.06l0,0 c-0.093,1.684-0.824,3.27-2.043,4.436l-5.804,5.545l-1.923,3.633l3.854-0.795c0.645-0.133,1.272,0.297,1.38,0.947l0,0 c0.087,0.521-0.19,1.036-0.673,1.251l-3.722,1.658l0,0c-1.802,1.963-4.394,3.007-7.054,2.842l-4.529-0.282L239.456,223.839z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M195.274,231.876c-0.592,1.746-1.185,3.492-1.777,5.238c-0.198,0.583,0.712,0.878,0.909,0.294 c0.592-1.746,1.185-3.492,1.777-5.238C196.381,231.588,195.472,231.293,195.274,231.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M197.384,233.135c0.055-0.612-0.9-0.655-0.955-0.042c-0.065,0.723-0.13,1.446-0.196,2.169 c-0.055,0.612,0.9,0.655,0.955,0.042C197.254,234.581,197.319,233.858,197.384,233.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M237.685,230.256c-0.438-1.335-0.876-2.67-1.313-4.005c-0.19-0.579-1.126-0.381-0.934,0.205 c0.438,1.335,0.876,2.67,1.313,4.005C236.941,231.039,237.877,230.841,237.685,230.256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M97.006,452.43l2.44-1.516l12.58,0.219c0,0,2.237,2.784,2.237,10.107h-9.365L97.006,452.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M175.24,288.828c0,0,1.449,19.743,0.624,29.682c-1.463,17.635-3.235,45.841-7.623,63.416 c0,25.114-2.772,45.687-1.744,69.207c-4.596,0.125-8.038-0.344-12.634-0.219c-1.622-16.678-5.446-28.52-8.204-46.736 c-0.924-6.104,1.722-15.613,3.661-21.225c-3.161-10.864-6.705-49.288-7.807-56.495c-1.714-11.205,1.48-22.049,3.374-33.224 L175.24,288.828z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183218327345238599700000011472820731153795211_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.2239,
    y1: 298.8764,
    x2: 122.6679,
    y2: 483.6749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E4988"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183218327345238599700000011472820731153795211_)"
    },
    d: "M163.222,296.397 c-9.049,27.574-19.898,65.999-33.703,89.31c-1.141,25.103-12.752,41.905-17.493,65.426c-4.626,0.125-7.954-0.344-12.58-0.219 c2.468-16.678,6.8-63.603,10.317-69.362c1.466-11.561,6.488-54.88,7.202-62.605c1.035-11.205,4.086-19.569,10.043-25.713 L163.222,296.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F4F4"
    },
    d: "M106.219,461.239c-0.024-5.152-4.206-9.321-9.363-9.321h0c-5.157,0-9.339,4.169-9.363,9.321 H106.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F4F4"
    },
    d: "M185.661,461.239c-0.024-5.152-4.206-9.321-9.363-9.321l0,0c-5.157,0-9.339,4.169-9.363,9.321 H185.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F4F4"
    },
    d: "M176.298,451.918l-9.8-0.786l-12.634-0.219c0,0-1.99,4.825-1.99,10.325h21.183L176.298,451.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M129.106,379.879c-4.509,3.715-9.018,7.429-13.527,11.144c-0.821,0.676,0.353,1.838,1.167,1.167 c4.509-3.715,9.018-7.429,13.527-11.144C131.094,380.371,129.92,379.208,129.106,379.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M118.824,393.142c-0.646,0.647-1.293,1.293-1.939,1.94c-0.752,0.752,0.415,1.92,1.167,1.167 c0.647-0.646,1.293-1.293,1.94-1.939C120.743,393.557,119.576,392.389,118.824,393.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M111.096,445.283l-6.909,0.725c-1.046,0.11-1.057,1.762,0,1.651l6.909-0.725 C112.142,446.824,112.154,445.172,111.096,445.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M111.43,443.081l-3.048,0.554c-1.044,0.19-0.602,1.781,0.439,1.592 c1.016-0.185,2.032-0.37,3.048-0.554C112.912,444.483,112.47,442.892,111.43,443.081z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009554271712947454140000009546048390288461459_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.5775,
    y1: 215.6801,
    x2: 145.5775,
    y2: 309.5538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#727B92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9845,
    style: {
      stopColor: "#957B92"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009554271712947454140000009546048390288461459_)"
    },
    d: "M134.368,200.279 c-3.547,0.535-6.823,1.384-9.577,2.482c-6.931,2.766-12.742,8.321-12.185,16.406c0.774,11.23,4.459,22.209,7.669,32.916 c2.381,7.94,4.832,29.98-0.45,53.387c15.472,5.751,42.335,9.973,57.4,3.227c0.555-30.296,4.554-57.637-4.463-91.52 C168.253,200.233,150.265,197.878,134.368,200.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58657D"
    },
    d: "M176.491,308.446c-8.935,4.258-18.967,3.577-28.507,2.252c-9.36-1.3-18.565-3.445-27.626-6.109 c-1.022-0.3-1.405,1.306-0.389,1.605c10.508,3.089,21.237,5.501,32.139,6.669c8.635,0.925,17.293,0.778,25.26-3.019 C178.325,309.389,177.442,307.993,176.491,308.446z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M151.852,211.126c-0.154-0.64-1.154-0.414-0.999,0.229c7.855,32.577,11.024,66.156,9.402,99.627 c-0.032,0.659,0.991,0.704,1.023,0.045C162.905,277.469,159.727,243.787,151.852,211.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E342E"
    },
    d: "M136.222,190.857c-2.932-8.183-10.805-14.267-12.181-22.85c-0.654-4.08-2.92-7.615-1.167-11.357 c1.753-3.742,5.737-6.328,9.869-6.406c1.522-5.105,6.959-9.966,12.249-10.593c1.49-0.177,3.055-0.096,4.406,0.559 c1.35,0.655,2.445,1.965,2.543,3.463c1.933-3.79,8.024-4.756,11.929-3.067c3.905,1.689,6.369,5.889,6.7,10.131 c0.33,4.242-1.222,8.463-3.571,12.011s-5.461,6.514-8.586,9.401L136.222,190.857z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CABA"
    },
    d: "M134.586,183.553c1.371,5.885,1.957,11.952,1.738,17.99c-0.589-0.51-2.458,0.242-2.811,0.937 c-0.352,0.695-0.14,1.572,0.335,2.189c0.474,0.618,1.167,1.025,1.857,1.386c4.952,2.592,10.737,3.563,16.264,2.729 c1.013-0.153,2.044-0.375,2.909-0.924c0.865-0.55,1.544-1.489,1.531-2.514c-0.014-1.11-0.831-2.083-1.811-2.604 c-0.98-0.521-2.107-0.676-3.207-0.822c-0.319-4.492-1.082-8.673-1.401-13.164L134.586,183.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A890"
    },
    d: "M146.953,199.622c1.44,0.773,2.914,1.453,4.415,2.049c-0.329-4.396-1.065-8.508-1.378-12.916 l-15.404-5.202c0.241,1.034,0.456,2.074,0.646,3.118c0.561,3.086,2.249,5.852,4.665,7.852 C142.134,196.376,144.362,198.232,146.953,199.622z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CABA"
    },
    d: "M159.358,157.677c0.768,0.228,1.318,0.899,1.407,1.695c1.107,9.889,2.036,18.176-0.46,27.788 c-0.922,3.549-2.66,7.345-6.088,8.647c-3.329,1.264-7.048-0.286-10.051-2.199c-3.871-2.466-7.325-5.586-10.17-9.188 c-2.449,0.59-4.309-0.308-5.648-2.441c-1.168-1.862-1.642-4.384-0.44-6.225c1.202-1.841,4.433-2.159,5.469-0.22 c-0.039-4.064,1.634-6.302,3.695-9.805c-0.674-2.437-1.193-5.248,0.594-7.037c0.549-0.549,1.259-0.906,1.97-1.218 C144.736,155.239,153.594,155.966,159.358,157.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E342E"
    },
    d: "M148.836,165.133c-2.884-1.473-6.151-1.122-8.692,0.862c-0.763,0.596,0.309,1.655,1.065,1.065 c1.981-1.547,4.643-1.763,6.867-0.626C148.937,166.874,149.7,165.575,148.836,165.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E342E"
    },
    d: "M161.635,164.867c-2.034-1.601-5.048-1.442-6.763,0.575c-0.596,0.701,0.416,1.722,1.016,1.016 c1.162-1.367,3.274-1.721,4.73-0.575C161.337,166.449,162.361,165.439,161.635,164.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4950"
    },
    d: "M146.314,168.541c-0.07-0.961-1.577-0.969-1.506,0c0.07,0.958,0.14,1.917,0.21,2.875 c0.07,0.961,1.577,0.968,1.506,0C146.454,170.458,146.384,169.5,146.314,168.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4950"
    },
    d: "M159.895,167.957c-0.07-0.961-1.577-0.969-1.506,0c0.07,0.958,0.14,1.917,0.21,2.875 c0.07,0.961,1.577,0.969,1.506,0C160.035,169.874,159.966,168.915,159.895,167.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4950"
    },
    d: "M150.852,185.151c-1.916-0.216-3.572-1.183-4.796-2.655c-0.62-0.746-1.68,0.324-1.065,1.065 c1.492,1.796,3.554,2.836,5.86,3.096C151.813,186.766,151.805,185.259,150.852,185.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A890"
    },
    d: "M149.118,188.786c-0.944-0.027-1.848-0.244-2.695-0.664c-0.865-0.429-1.629,0.869-0.76,1.3 c1.09,0.541,2.239,0.836,3.455,0.87C150.088,190.32,150.087,188.814,149.118,188.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A890"
    },
    d: "M156.049,178.069c-0.833,0.819-1.886,1.162-3.042,1.056c-0.965-0.088-0.959,1.418,0,1.506 c1.533,0.14,3.015-0.422,4.107-1.497C157.806,178.453,156.741,177.389,156.049,178.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A890"
    },
    d: "M132.736,180.405c-1.348-0.168-1.283-1.829-0.226-2.334c0.874-0.418,0.111-1.717-0.76-1.3 c-1.092,0.522-1.759,1.758-1.528,2.96c0.239,1.247,1.31,2.03,2.514,2.181C133.695,182.03,133.686,180.523,132.736,180.405z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727B92"
    },
    d: "M131.814,205.576c0.843-2.975,1.687-5.951,2.53-8.926c3.537,2.766,7.924,4.902,12.245,6.121 c0.141,3.466,0.186,7.228,0.327,10.695C141.284,212.51,135.336,210.073,131.814,205.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727B92"
    },
    d: "M152.148,209.764c-0.426-3.976-0.851-7.952-1.277-11.929c2.412,0.398,4.699,0.888,7.111,1.286 c0.368,2.84,0.629,5.7,0.997,8.54C156.784,208.008,154.095,208.695,152.148,209.764z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M145.727,209.63c-0.457-2.001-0.913-4.003-1.369-6.004c-0.083-0.366-0.568-0.536-0.845-0.263 c-1.817,1.784-3.299,3.825-4.415,6.114c-0.286,0.587,0.573,1.146,0.861,0.555c0.943-1.933,2.156-3.675,3.615-5.238 c0.385,1.688,0.77,3.377,1.155,5.065C144.875,210.501,145.874,210.274,145.727,209.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M158.946,205.826c-0.85-1.173-1.7-2.347-2.551-3.52c-0.23-0.317-0.764-0.152-0.865,0.189 c-0.547,1.853-1.094,3.706-1.642,5.559c-0.187,0.632,0.788,0.948,0.975,0.315c0.451-1.526,0.901-3.052,1.352-4.577 c0.659,0.909,1.317,1.818,1.976,2.727C158.578,207.052,159.329,206.355,158.946,205.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M139.344,209.435c-1.473-0.988-2.947-1.976-4.42-2.964c-0.549-0.368-1.102,0.494-0.555,0.861 c1.473,0.988,2.947,1.976,4.42,2.964C139.338,210.664,139.891,209.802,139.344,209.435z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727B92"
    },
    d: "M110.112,260.556c-1.711,2.476-3.473,5.004-5.924,6.749c-2.452,1.746-5.774,2.582-8.518,1.345 c-3.102-1.398-4.645-5.084-4.541-8.484c0.104-3.401,1.526-6.604,2.923-9.706c1.46-3.242,9.411-21.583,10.871-24.825 c3.666-8.138,8.251-17.124,16.77-19.784c3.272-1.022,6.987-0.911,9.967,0.783c8.631,4.908,3.473,12.009-0.519,17.786 C126.294,231.432,114.958,253.544,110.112,260.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727B92"
    },
    d: "M109.865,263.139l14.316,34.86c-3.819,1.915-3.098,1.553-6.918,3.468 c-9.213-11.601-21.398-23.527-25.64-37.74c-1.09-3.654-0.5-1.416,0.808-4.999c1.308-3.582,5.707-6.254,9.048-4.417l0,0 C105.603,255.622,108.768,258.954,109.865,263.139z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0CABA"
    },
    points: "124.181,297.999 129.834,307.689 121.28,311.645 117.264,301.467  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CABA"
    },
    d: "M122.508,309.55c-0.272-1.272-2.316-1.113-2.041,0.175c0.359,1.684,1.012,4.832-0.313,6.226 c-0.91,0.957,0.661,2.272,1.567,1.319C123.488,315.413,122.992,311.814,122.508,309.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CABA"
    },
    d: "M124.305,308.03c-0.569-1.175-2.498-0.478-1.922,0.711c1.571,3.244,1.853,6.776,0.644,10.191 c-0.437,1.233,1.411,2.121,1.851,0.879C126.268,315.888,126.127,311.792,124.305,308.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CABA"
    },
    d: "M126.347,306.662c-0.676-1.132-2.348,0.053-1.674,1.181c2.1,3.519,2.539,7.494,1.413,11.414 c-0.364,1.268,1.654,1.63,2.015,0.374C129.382,315.17,128.717,310.634,126.347,306.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CABA"
    },
    d: "M128.638,305.448c-0.703-1.116-2.377,0.067-1.674,1.181c1.895,3.005,2.586,6.378,2.047,9.886 c-0.2,1.303,1.814,1.678,2.015,0.374C131.651,312.826,130.83,308.923,128.638,305.448z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M121.397,294.624c-1.85,0.763-3.7,1.526-5.55,2.289c-0.607,0.25-0.256,1.213,0.356,0.961 c1.85-0.763,3.7-1.526,5.55-2.289C122.36,295.334,122.009,294.372,121.397,294.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M108.275,260.647c-2.169-0.575-4.338-1.15-6.508-1.725c-0.638-0.169-0.82,0.839-0.187,1.007 c2.021,0.536,4.043,1.072,6.064,1.608c0.045,0.024,0.088,0.049,0.146,0.06c0.099,0.019,0.198,0.038,0.297,0.057 C108.744,261.781,108.904,260.814,108.275,260.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M106.647,261.705c-0.814-0.019-1.627-0.039-2.441-0.058c-0.658-0.016-0.565,1.005,0.088,1.02 c0.814,0.019,1.627,0.039,2.441,0.058C107.393,262.741,107.3,261.721,106.647,261.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M127.467,226.012c-3.193,8.447-10.685,24.172-16.172,31.346c-0.4,0.522,0.382,1.185,0.784,0.66 c5.539-7.242,13.09-23.037,16.314-31.566C128.624,225.838,127.7,225.395,127.467,226.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394252"
    },
    d: "M126.909,232.197c-1.223,1.213-2.446,2.426-3.669,3.639c-0.468,0.465,0.318,1.121,0.784,0.66 c1.223-1.213,2.446-2.426,3.669-3.639C128.161,232.392,127.374,231.736,126.909,232.197z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.f76eb00101825817a888cf6b6b37e2bf.svg";
export { ForwardRef as ReactComponent };